<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <defs>
    <style>
      .cls-1 {
        stroke-linecap: round;
      }
      .cls-1, .cls-2 {
        fill: none;
        stroke-linejoin: round;
      }
    </style>
  </defs>
  <path class="cls-1" d="m14.68,48.28h-2.35c-3.03-.02-5.74-1.9-6.85-4.78-3.29-8.34-3.33-17.66-.15-26.05,1.09-2.83,3.8-4.69,6.8-4.67h35.83c4.62-.02,8.66,3.23,9.69,7.81,1.78,7.99.43,16.25-1.07,21.96l-.68,1.82c-1.22,2.37-3.6,3.87-6.24,3.96h-17.31"/>
  <path class="cls-1" d="m37.7,20.9h7.24c1.35,0,2.45,1.11,2.45,2.48v24.95h-12.13v-24.95c0-1.37,1.08-2.48,2.44-2.48Z"/>
  <path class="cls-1" d="m16.28,20.9h6.41c1.56,0,2.85,1.31,2.85,2.9v2.08c0,1.59-1.29,2.9-2.85,2.9h-6.41c-1.57,0-2.86-1.31-2.86-2.9v-2.08c0-1.59,1.29-2.9,2.86-2.9Z"/>
  <path class="cls-1" d="m55.42,45.86h5.78v-2.61"/>
  <path class="cls-1" d="m35.26,33.6H3.11"/>
  <path class="cls-2" d="m40.18,33.6h-1.62"/>
  <path class="cls-1" d="m58.31,33.6h-10.92"/>
  <path class="cls-1" d="m23.54,53.92c3.06-.02,5.49-2.52,5.49-5.62-.02-3.1-2.48-5.58-5.54-5.58-3.03.02-5.49,2.52-5.49,5.6s2.47,5.6,5.52,5.6h.02Z"/>
</svg>